module.exports = __webpack_public_path__ + "img/06.5b410396.png";